export const API_URL = "https://new-api.nokorshop.com";

export const TOKEN_LABEL = 'sastra-film-dashboard-token'
